{
    "organization": {
        "add_team_member_modal": {
            "submit": "Add",
            "title": "Add a member"
        },
        "content_hubs_list": {
            "actions": {
                "add_member": "Add a member",
                "join": "Join"
            },
            "empty": "No content hubs",
            "messages": {
                "join_failed": "Failed to join the content hub team",
                "joined": "You were added to {0}",
                "load_failed": "Failed to load content hubs",
                "member_add_failed": "Failed to add {0} to team",
                "member_added": "{0} was added to {1}",
                "member_not_in_org": "This user is not a Member in this Organization. In order to add this user to the Content Hub, please add this user as an Organization Member first."
            },
            "table": {
                "content_hub": "Content hub",
                "creation_date": "Creation date"
            }
        },
        "creation": {
            "error": "Failed to create organization",
            "subtitle": "This will create a profile page for your team.",
            "success": "Organization created successfully",
            "title": "Manage your events from one place"
        },
        "details": {
            "account_manager_options": "Account Manager Options",
            "allow_non_unique_email": "User creation with shared email addresses",
            "allow_non_unique_email_tooltip": "Remember that when you turn this setting on, you are removing the requirement for the attendees’ email address to be unique.",
            "bs_is_blocked": "Is Blocked",
            "bs_is_spotme": "Is SpotMe Org",
            "bs_is_spotme_tooltip": "SpotMe orgs are excluded from license checks and some email notifications.",
            "content_hubs_enabled": "Content hubs enabled",
            "display_name": "Organization name",
            "enable_anonymization": "Enable Behavioral Data Anonymization",
            "enable_chat_api": "Enable Chat API",
            "enable_chat_api_tooltip": "Exposes chat conversation metadata over the data API. This is personal data, so only enable it once the organization has a data processing agreement covering it.",
            "enable_rtmps_slides": "Enable Slides in RTMPs",
            "entitlements_enabled": "Entitlements Enabled",
            "entitlements_v2": "Auto Entitlements",
            "hive": "Hive",
            "hive_customer_id": "Customer ID",
            "hive_partner_id": "Partner ID",
            "hive_partner_token": "Partner Token",
            "life_science": "Life science",
            "name": "Organization",
            "org_industry": "Organization industry",
            "other": "Other industries",
            "paid_packages": "Paid packages",
            "password_rotation_policy": "Password Rotation Policy",
            "password_rotation_policy_duration": "Duration (seconds)",
            "sf_account_id": "Account ID",
            "sf_account_id_tooltip": "The Salesforce Account ID",
            "show_live_captions": "Show Live Captions",
            "show_studio_express": "Show Spotme Express",
            "superadmin_options": "Superadmin Options",
            "support_options": "Support Options",
            "update_error": "Failed to save organization details",
            "update_success": "Organization details saved"
        },
        "memberships": {
            "all_orgs_in_system": "The following organizations are registered in the system.",
            "load_error": "Could not load the organizations. Please try again later.",
            "member_in_orgs": "You are a member in the following organizations.",
            "name": "Name",
            "no_memberships": "No memberships found.",
            "owner": "Owner",
            "salesforce_id": "Salesforce ID"
        },
        "pax_management": {
            "bulk": {
                "cancel": "Cancel user",
                "cancel_confirm": "Are you sure you want to cancel {0} in all their workspaces? They will be no longer able to login into any of them.",
                "cancel_failure": "Failed to cancel sessions: {0}",
                "cancel_success": "User was canceled successfully from all workspaces",
                "delete": "Delete",
                "log_out": "Log out",
                "log_out_confirm": "Are you sure you want to invalidate {0} in all their workspaces?",
                "log_out_failure": "Failed to invalidate sessions {0}",
                "log_out_success": "All sessions were invalidated"
            },
            "deleted_user": {
                "message": "This user has requested their data to be deleted on {0}",
                "title": "Deleted user"
            },
            "sections": {
                "privacy": {
                    "accepted_policy": "Accepted {0} privacy policy",
                    "accepted_policy_with_name": "{0} accepted {1} privacy policy",
                    "action": "Action",
                    "fetch_failure": "Failed to fetch accepted legal documents.",
                    "nothing_found": "No accepted legal documents found for this email.",
                    "time": "Time",
                    "title": "Privacy",
                    "unsubscribed": "Unsubscribed from marketing emails on workspace: {0}"
                },
                "workspaces": {
                    "activation": "Activation time",
                    "device": "Device",
                    "fetch_failure": "Failed to fetch user sessions.",
                    "headers": {
                        "full_name": "Full name",
                        "workspace": "Workspace"
                    },
                    "no_sessions": "No sessions found for this event.",
                    "nothing_found": "No sessions found for this email.",
                    "session_actions": {
                        "ban": "Cancel user from workspace",
                        "ban_confirm": "Are you sure you want to cancel {0} from accessing {1}?",
                        "ban_failure": "Failed to cancel workspace sessions",
                        "ban_success": "Workspace sessions were cancelled",
                        "go_to_user": "Go to user profile",
                        "kick": "Invalidate user session",
                        "kick_confirm": "Are you sure you want to invalidate {0} sessions in {1}?",
                        "kick_failure": "Failed to invalidate workspace sessions",
                        "kick_success": "Workspace sessions were invalidated",
                        "view_all": "View all sessions"
                    },
                    "sessions_title": "Sessions",
                    "title": "Workspaces",
                    "user_cancelled": "User cancelled"
                }
            }
        },
        "product_mappings": {
            "actions": {
                "add_package": "Add Package Mapping",
                "add_seat": "Add Seat Mapping",
                "edit": "Edit mapping",
                "remove": "Remove mapping"
            },
            "columns": {
                "bundle_name": "Bundle Name",
                "erp_product_code": "ERP Product Code",
                "product_name": "Product Name",
                "product_type": "Product Type"
            },
            "errors": {
                "already_exists": "A mapping for that product already exists",
                "invalid": "Invalid Mapping",
                "list": "Error getting information about product mappings",
                "remove": "Error occurred while removing mapping",
                "save": "Error occurred while adding mapping"
            },
            "form": {
                "package_names": "Package names",
                "package_names_tip": "These should be package names like \"agenda\"",
                "title_edit_package": "Edit Package Mapping"
            },
            "remove_confirm": "Do you want to remove mapping to {0}?",
            "types": {
                "package": "package",
                "subscription": "seats"
            }
        },
        "sales_contact": {
            "your_representative": "Your Sales Representative"
        },
        "workspaces": {
            "form": {
                "activation_codes": "Event passwords",
                "activation_codes_hint": "You need to enable event passwords for your organization in order to use them in your workspaces.",
                "ai_mapping_for_ocr_lead_scanning": "Optical scan - automatic mapping",
                "ai_mapping_for_ocr_lead_scanning_hint": "Enable automatic AI-based field mapping to speed up the lead scanning process.",
                "attendance_criteria_accordeon": "Attendance criteria",
                "burn_token_limit": "Webapp token usage limit",
                "burn_token_limit_hint": "Maximum number of use a single token will work for.",
                "category_label": "Category label",
                "category_multiselect": "Multiselect",
                "category_values": "Category values",
                "category_values_placeholder": "Add a category value",
                "container_app": "Container app",
                "container_app_hint": "This workspace will be visible only in this app",
                "container_app_placeholder": "Select a container app",
                "cookie_banner": "Show cookies banner (webapp)",
                "enable_category": "Enable category",
                "enable_studio_virtual_backgrounds": "Studio - Virtual background (Experimental)",
                "enable_studio_virtual_backgrounds_hint": "This is an experimental feature. Performance may vary significantly depending on the speaker's hardware and setup. See <a href='{0}' target='_blank'>hardware requirements</a> and <a href='{1}' target='_blank'>usage recommendations</a>.",
                "enable_video_calls_hard_delete_recordings": "Breakout rooms - Hard delete recordings and transcripts",
                "enable_video_calls_hard_delete_recordings_hint": "Allow workspace managers to delete breakout room assets including recordings, captions and transcripts. Once deleted it will not be possible to retrieve these assets in any way.",
                "force_anonymization": "Behavioural data anonymization",
                "force_anonymization_hint": "You have the flexibility to choose between customizing this setting individually or globally just for new workspaces. All new webinars and Content Hubs users data will be always anonymized by default.",
                "force_anonymization_off": "Per workspaces",
                "force_anonymization_off_hint": "during workspace creation, you can decide whether to anonymize data and apply it to all users.",
                "force_anonymization_on": "All workspaces",
                "force_anonymization_on_hint": "all or selected users of new workspaces will be anonymized.",
                "general": "General",
                "leads": "Leads",
                "legal": "Legal",
                "privacy_documents": "Privacy policies",
                "privacy_documents_placeholder": "Choose polices",
                "servers_location": "Data location",
                "servers_location_placeholder": "Select a server location",
                "show_access_as": "Allow impersonating users",
                "show_access_as_hint": "Show the \"Access As ...\"  button in user profile and export the impersonating link in the XLS file.",
                "studio_breakout": "Studio and video breakouts",
                "timezone": "Time zone",
                "timezone_placeholder": "Time zone",
                "unrestricted_workspace_duration": "Do not restrict workspace duration",
                "update_success": "Organization data saved"
            }
        },
        "workspaces_list": {
            "actions": {
                "add_member": "Add a member",
                "join": "Join"
            },
            "empty": "No workspaces",
            "messages": {
                "join_failed": "Failed to join the event team",
                "joined": "You were added to {0}",
                "load_failed": "Failed to load workspaces",
                "member_add_failed": "Failed to add {0} to workspace",
                "member_added": "{0} was added to {1}",
                "member_not_in_org": "This user is not a Member in this Organization. In order to add this user to the Workspace, please add this user as an Organization Member first."
            },
            "table": {
                "date": "Date",
                "date_range": "{0} to {1}",
                "location": "Location",
                "workspace": "Workspace"
            },
            "views": {
                "current": "Live",
                "future": "Future",
                "past": "Past",
                "templates": "Templates"
            },
            "views_label": "Workspaces by period"
        }
    },
    "organizations": {
        "entitlements": {
            "assign": {
                "confirm": {
                    "acknowledgement": "I understand that entitlements transferred to a workspace cannot be reassigned back to the organization.",
                    "message": "You are assigning {product} entitlements to the {workspace} workspace.",
                    "quantity": "The quantity transferred is {quantity}.",
                    "title": "Confirm transfer"
                },
                "confirm_transfer": "Confirm transfer",
                "error": "An error occurred while making the transaction. Try again later.",
                "intro": "Below is the list of entitlements available for your organization. You can transfer entitlements from your organization to the {workspace} workspace to cover your current or future usage. Entitlements transferred to a workspace cannot be reassigned back to the organization.",
                "issues": {
                    "covered": "This workspace already has an entitlement for this product.",
                    "quantity": "Enter a whole quantity between 1 and {max}."
                },
                "no_pools": "There are no entitlements available for this product.",
                "pools": {
                    "available": "Available",
                    "details": "Show the details of the entitlement",
                    "expiration": "Pool expiration date",
                    "id": "Pool ID",
                    "title": "Available entitlements"
                },
                "product_error": "Error getting information about the selected product.",
                "quantity": "Quantity",
                "quantity_title": "Transferred quantity",
                "success": "Transaction executed.",
                "summary": {
                    "after": "After transaction: {count}",
                    "after_single": "After transaction: the functionality can be used",
                    "after_usage": "After transaction: {used}/{available}",
                    "available": "Available: {count}",
                    "current_usage": "Current usage: {used}/{available}",
                    "states": {
                        "covered": "Current usage: the functionality is used and covered by an entitlement",
                        "uncovered": "Current usage: the functionality is used but is not covered by any entitlement",
                        "unused": "Current usage: not used yet"
                    }
                },
                "title": "Transfer {product}",
                "workspace_error": "Error getting information about the selected workspace."
            },
            "details": {
                "children": "Attached transactions",
                "error": "Error getting information about the entitlement.",
                "expired": "Expired",
                "fields": {
                    "expired_on": "Expired on",
                    "id": "ID",
                    "lifetime": "Lifetime",
                    "purchase_date": "Purchase date",
                    "quantity": "Quantity",
                    "transaction_author": "Transaction author",
                    "valid_from": "Valid from",
                    "valid_to": "Valid to",
                    "workspace": "Workspace",
                    "workspace_valid_from": "Valid on workspace from",
                    "workspace_valid_to": "Valid on workspace to"
                },
                "modal_title": "Entitlement details",
                "parent": "Parent entitlement",
                "titles": {
                    "account": "Entitlement assigned to organization",
                    "event": "Entitlement assigned to workspace",
                    "expired": "Entitlement expired",
                    "expired_event": "Entitlement expired on workspace",
                    "settlement": "Entitlement settled on workspace",
                    "transaction": "Entitlement transferred to workspace"
                }
            },
            "export": {
                "button": "Export XLS",
                "titles": {
                    "events": "Exporting Workspaces",
                    "transactions": "Exporting Transactions"
                }
            },
            "manager": {
                "footnote": "\"Seat\" means subscription in the sense of the SpotMe Master Terms of Services or equivalent.",
                "tabs": {
                    "assign": "Assign Entitlement",
                    "overview": "Overview",
                    "workspace": "Workspace Entitlements",
                    "workspaces": "Workspaces"
                }
            },
            "overage": {
                "title": "Your workspaces have missing entitlements!",
                "total": "Your total overage is:",
                "workspaces": "The following workspaces have overage:"
            },
            "overview": {
                "all_transactions_intro": "In the table below you can find the history of the entitlement transactions of your organization.",
                "available": "Available: {count}",
                "no_product_transactions": "There are no transactions for this entitlement.",
                "no_products": "{name} hasn't purchased any products.",
                "no_transactions": "{name} hasn't made any transactions.",
                "purchased_error": "Error getting information about purchased products",
                "see_all": "See all transactions",
                "see_pool": "See pool transactions",
                "superadmin": {
                    "flush_cache": "Flush Cache",
                    "flush_error": "Could not flush the entitlements cache.",
                    "flush_success": "The entitlements cache was flushed.",
                    "title": "Superadmin Options"
                },
                "title": "Transaction History"
            },
            "plans": {
                "expires": "Expires",
                "id": "ID",
                "title": "Active plans",
                "types": {
                    "package": "tokens",
                    "subscription": "seats"
                },
                "usage": "You have {0} {1} out of {2} left"
            },
            "product_block": {
                "add_title": "Click to transfer the entitlement to this workspace",
                "installed": "Installed",
                "not_used": "Not used",
                "overage": "Overage",
                "overage_title": "Usage is not covered by any entitlement",
                "settle": "Settle",
                "usage_details": {
                    "sentence": "{terms} = {subscriptions}.",
                    "spotme_filtered": "({count} SpotMe user filtered). | ({count} SpotMe users filtered).",
                    "subscriptions": "{count} subscription | {count} subscriptions",
                    "terms": {
                        "cancelled": "{count} cancelled user | {count} cancelled users",
                        "cancelled_activated": "{count} cancelled activated user | {count} cancelled activated users",
                        "expired": "{count} expired user | {count} expired users",
                        "test": "{count} test user | {count} test users",
                        "users": "{count} user | {count} users"
                    }
                },
                "usage_error": "Could not retrieve usage"
            },
            "settle": {
                "comment": "Comment",
                "error": "The transaction failed. Try again.",
                "package_message": "Are you sure you want to assign {product} to {workspace}?",
                "seat_count": "Number of seats",
                "seats_message": "How many seats do you want to assign to {workspace}?",
                "success": "The transaction was successful.",
                "title": "Settle usage"
            },
            "transactions": {
                "headers": {
                    "available": "Available",
                    "credit": "Credit",
                    "date": "Date",
                    "debit": "Debit",
                    "details": "Details"
                },
                "kinds": {
                    "expired": "{product} expired",
                    "pool_expired": "{product} pool expired",
                    "pool_received": "{product} pool received",
                    "received": "{product} received",
                    "settled": "{product} settled",
                    "transferred": "{product} transferred"
                },
                "load_error": "Error getting information about transactions.",
                "page_error": "Could not load the transactions. Try again.",
                "show_details": "Show the details of the transaction"
            },
            "workspace": {
                "intro": "Below you can find the entitlements of the {workspace} workspace.",
                "load_error": "Error getting information about workspace products."
            },
            "workspaces": {
                "detailed_view": "Detailed view",
                "empty": {
                    "live": "{name} doesn't have any future workspaces.",
                    "past": "{name} doesn't have any past workspaces."
                },
                "load_error": "Error getting information about workspace entitlements",
                "tabs": {
                    "live": "Live",
                    "past": "Past"
                }
            }
        },
        "members": {
            "actions": {
                "add": "Add a member",
                "clear_phone": "Remove user phone",
                "promote": "Promote to member",
                "remove": "Remove member"
            },
            "add_modal": {
                "email": "Email",
                "role": "Role",
                "title": "Add a new member"
            },
            "confirm": {
                "add_role": "You are adding the {role} role to {name}. Are you sure?",
                "change_role": "You are changing the role of {name} to {role}. Are you sure?",
                "clear_phone": "Are you sure you want to remove this user's phone number? He or she will be informed of this change via email.",
                "clear_phone_title": "Remove this user's phone number",
                "remove": "You are about to remove {name} from {org}. It will also revoke access to all workspaces in {org}.",
                "remove_role": "You are removing the {role} role from {name}. Are you sure?"
            },
            "email_line": {
                "last_login": "Last login: {date}",
                "not_activated": "not activated"
            },
            "errors": {
                "clear_phone": "An error occurred while removing the phone number.",
                "load": "Failed to fetch the member list.",
                "remove": "An error occurred while removing the member.",
                "role_change": "Failed to update the member roles."
            },
            "flashes": {
                "phone_removed": "{name}'s phone number was removed from their profile.",
                "relation_added": "A new relation was established in {org}.",
                "removed": "{name} was removed from {org}."
            },
            "headers": {
                "actions": "Actions",
                "api_developer": "API Developer",
                "entitlement_manager": "Entitlement Manager",
                "extra_roles": "Additional roles",
                "name": "Name",
                "role": "Role"
            },
            "inherited_role": "This role cannot be removed as it is inherited.",
            "listing_items": "Listing {count} member|Listing {count} members",
            "listing_results": "Listing {count} search result|Listing {count} search results",
            "none_found": "No members found.",
            "role_hints": {
                "admin": "can create workspaces and promote other members",
                "guest": "only has access to the workspaces",
                "member": "can see other members",
                "organizer": "can see other members, create and join workspaces"
            },
            "roles": {
                "admin": "Admin",
                "guest": "Guest",
                "member": "Member",
                "organizer": "Organizer"
            },
            "search_placeholder": "Search members",
            "toggle_add": "Add role",
            "toggle_remove": "Remove role"
        },
        "packages": {
            "badges": {
                "deprecated": "Deprecated",
                "draft": "Draft",
                "new_version": "New version!"
            },
            "description": {
                "add": "Add a new documentation",
                "beta_url_required": "Beta contact Url is a required field for beta modules",
                "deprecated": "This module is deprecated and won’t be displayed in the marketplace.",
                "fields": {
                    "beta": "Beta",
                    "categories": "Categories",
                    "changelog": "What's new?",
                    "description": "Description",
                    "description_url": "Documentation URL",
                    "icon": "Icon",
                    "image_1": "Image 1",
                    "image_2": "Image 2",
                    "image_3": "Image 3",
                    "image_4": "Image 4",
                    "name": "Module",
                    "paid": "Paid",
                    "paid_add_on": "Paid add-on",
                    "stage_url": "Beta contact url",
                    "state": "Status",
                    "tagline": "Tagline",
                    "title": "Title",
                    "version": "Version",
                    "visibility": "Visibility"
                },
                "load_error": "Failed to load the package description.",
                "save_error": "Failed to save package description.",
                "save_success": "Package description saved successfully.",
                "sections": {
                    "module_details": "Module details",
                    "version_documentation": "Version documentation"
                },
                "states": {
                    "draft": "Draft",
                    "published": "Published"
                },
                "tips": {
                    "changelog": "Tell users what has changed with the new version of this module",
                    "description": "This field supports Markdown and HTML",
                    "description_url": "Paste here the link to the documentation for this module"
                },
                "title": "Module documentation"
            },
            "headers": {
                "latest_version": "Latest version",
                "released": "Released",
                "status": "Status",
                "title": "Title",
                "visibility": "Visibility"
            },
            "listing_items": "Listing {count} item|Listing {count} items",
            "listing_results": "Listing {count} search result|Listing {count} search results",
            "load_error": "Failed to load packages.",
            "none_found": "No packages found.",
            "search_placeholder": "Search by name, version or status...",
            "visibility": {
                "private": "Private",
                "public": "Public"
            }
        }
    }
}
